const config = {
  backendBaseUrl: process.env.VUE_APP_ACARA_WEB_BACKEND_URL || "http://localhost:8000/api/v1",
  backendUrl: (process.env.VUE_APP_ACARA_WEB_BACKEND_URL || "http://localhost:8000/api/v1").replace('/api/v1', ''),
};

export default config;
